import React from "react";
import { withNamespaces } from 'react-i18next';

const AcEstudar = ({t}) => {
  return (
    <>
      <div className="accordion" id="accordionExample_estudar">
        {/* 1 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="estudar_heading1">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#estudar_collapse1"
              aria-expanded="true"
              aria-controls="estudar_collapse1"
            >
              {t('moduleFaqs:S7.A.A1.T') }
            </button>
          </h2>
          <div
            id="estudar_collapse1"
            className="accordion-collapse collapse"
            aria-labelledby="estudar_heading1"
            data-bs-parent="#accordionExample_estudar"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <ul>
                  <li>
                    <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S7.A.A1.LI1') }}></p>
                  </li>
                  <li>
                    <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S7.A.A1.LI2') }}></p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* 2 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="estudar_heading2">
            <button
              className="accordion-button collapsed text-left"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#estudar_collapse2"
              aria-expanded="true"
              aria-controls="estudar_collapse2"
            >
              {t('moduleFaqs:S7.A.A2.T') }
            </button>
          </h2>
          <div
            id="estudar_collapse2"
            className="accordion-collapse collapse"
            aria-labelledby="estudar_heading2"
            data-bs-parent="#accordionExample_estudar"
          >
            <div className="accordion-body">
              <p className="p_accordion"  dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S7.A.A2.P1') }}></p>
              <p className="p_accordion" >
                <span dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S7.A.A2.P2') }}></span>
                <a className='link' target='_blank' rel='noreferrer' href={t('moduleFaqs:S7.A.A2.Link.Link')} title={t('moduleFaqs:S7.A.A2.Link.Title')}>{t('moduleFaqs:S7.A.A2.Link.NameLink')}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (AcEstudar);
